import type {
  SoftTagsResponse,
  SoftTagsResponseDTO,
  Tags,
  TagsDTO,
} from '../types/tags.types';

/**
 * Maps TagsDTO to Tags
 */
export const mapTagsDTO = (dto: TagsDTO): Tags => {
  return {
    id: dto.id,
    timeseriesId: dto.timeseries_id,
    name: dto.name,
    description: dto.description,
    status: dto.status,
    unit: dto.unit,
    productionUnit: dto.production_unit,
    timeseriesType: dto.timeseries_type, // Optional, only if API provides this field
    site: dto.site,
    area: dto.area,
    region: dto.region,
    country: dto.country,
    createdBy: dto.created_by,
    createdAt: dto.created_at, // Keep as string
    executions: dto.executions,
  };
};

/**
 * Maps Tags to TagsDTO
 */
export const mapTagsToDTO = (tags: Tags): TagsDTO => {
  return {
    id: tags.id,
    timeseries_id: tags.timeseriesId,
    name: tags.name,
    description: tags.description,
    status: tags.status,
    unit: tags.unit,
    production_unit: tags.productionUnit,
    site: tags.site,
    area: tags.area,
    region: tags.region,
    country: tags.country,
    created_by: tags.createdBy,
    created_at: tags.createdAt, // Already a string
    executions: tags.executions,
  };
};

// Utility functions for mapping arrays
export const mapTagsDTOArray = (
  dtos: SoftTagsResponseDTO
): SoftTagsResponse => {
  return {
    count: dtos.count,
    size: dtos.size,
    page: dtos.page,
    sort_by: dtos.sort_by,
    sort_order: dtos.sort_order,
    results: dtos.results.map(mapTagsDTO),
  };
};
